import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "@/App";
import { ErrorBoundary } from "@/components/routing/error-boundary";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { UpdatePrompt } from "@/components/layout/update-prompt";
import { installChunkReloadListener } from "@/lib/chunk-reload";
import { stripReloadParam } from "@/lib/version";
import { AuthProvider } from "@/providers/auth-provider";
import { BusinessProvider } from "@/providers/business-provider";
import { QueryProvider } from "@/providers/query-provider";
import { ThemeProvider } from "@/providers/theme-provider";
import "@/index.css";

// A deployment can land while a tab is open, purging the chunk the next
// navigation is about to ask for. Catch that and reload for the new build only.
installChunkReloadListener();
// Clear the cache-busting query param a version reload leaves behind.
stripReloadParam();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <ErrorBoundary>
        <QueryProvider>
          <AuthProvider>
            <BusinessProvider>
              <TooltipProvider delayDuration={250}>
                <BrowserRouter>
                  <App />
                </BrowserRouter>
                <UpdatePrompt />
                <Toaster />
              </TooltipProvider>
            </BusinessProvider>
          </AuthProvider>
        </QueryProvider>
      </ErrorBoundary>
    </ThemeProvider>
  </StrictMode>,
);
